import DesktopMainNavigation from './desktop-main-navigation';
import MobilePanel from './mobile-panel';
import Hamburger from './hamburger';

/**
 * Wires up the whole navigation system: desktop panels, mobile panel and the
 * hamburger that opens it.
 *
 * Called from app.js as soon as the bundle runs instead of on `window.onload`
 * with the rest of the theme. The bundle is enqueued at the end of the body,
 * so the header is already in the DOM, while `load` waits for every image and
 * font on the page and left the menu unresponsive for several seconds.
 */
export default () => {
  DesktopMainNavigation();
  MobilePanel();

  const allHtml = document.querySelector('html');

  Hamburger.register('body', {
    onOpen: () => {
      allHtml.style.overflow = 'hidden';
    },
    onClose: () => {
      allHtml.style.overflow = 'auto';
      window.tasResetMobilePanels();
    },
  });
};
